import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { User } from '@/domain/entities/user/user'
import { DashboardTabType } from '@/domain/value_objects/dashboard/DashboardTabType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { DashboardModalStateModuleName } from '@/store/modules/modules'

export class DashboardModalStateViewModel {
  private store = useStore()

  dashboardUserList: ComputedRef<User[]> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/dashboardUserList`]
  )
  dashboardProgramLanguage: ComputedRef<ProgramLanguageType | 'All'> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/dashboardProgramLanguage`]
  )
  initialDashboardUser: ComputedRef<User | null> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/initialDashboardUser`]
  )
  courseSerial: ComputedRef<number> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/courseSerial`]
  )
  tabState: ComputedRef<DashboardTabType> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/tabState`]
  )
  isAddingDashboardUser: ComputedRef<boolean> = computed(
    () => this.store.getters[`${DashboardModalStateModuleName}/isAddingDashboardUser`]
  )
  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${DashboardModalStateModuleName}/isLoading`])
  error: ComputedRef<string | null> = computed(() => this.store.getters[`${DashboardModalStateModuleName}/error`])

  async isExistUser(userId: string): Promise<User> {
    return await this.store.dispatch(`${DashboardModalStateModuleName}/isExistUser`, { userId: userId })
  }

  addDashboardUser(user: User): void {
    this.store.commit(`${DashboardModalStateModuleName}/addDashboardUser`, { user: user })
  }

  removeDashboardUserList(): void {
    this.store.commit(`${DashboardModalStateModuleName}/removeDashboardUserList`)
  }

  removeTargetUsers(): void {
    this.store.commit(`${DashboardModalStateModuleName}/removeTargetUsers`)
  }

  setInitialDashboardUser(user: User | null): void {
    this.store.commit(`${DashboardModalStateModuleName}/setInitialDashboardUser`, { user: user })
  }

  setDashboardProgramLanguage(language: ProgramLanguageType | 'All'): void {
    this.store.commit(`${DashboardModalStateModuleName}/setDashboardProgramLanguage`, { language: language })
  }

  setCourseSerial(serial: number): void {
    this.store.commit(`${DashboardModalStateModuleName}/setCourseSerial`, serial)
  }

  setTabState(tabState: DashboardTabType): void {
    this.store.commit(`${DashboardModalStateModuleName}/setTabState`, tabState)
  }

  setIsAddingDashboardUser(isAdding: boolean): void {
    this.store.commit(`${DashboardModalStateModuleName}/setIsAddingDashboardUser`, isAdding)
  }
}
